import React from 'react'
import './Login.css'
function Login() {
  return (
    <div className='login'>
      <div className="login_container">
      <h1>Sign In</h1>
      <form >
        <h5>E-mail</h5>
        <input type="text" />
        <h5>Password</h5>
        <input type="password" />
        <button className='login_signInButton'>Sign In</button>
        <p>By continuing, you agree to Amazon's Conditions of Use and Privacy Notice.</p>
     <button>Create Your Amazon Account</button>
      </form>
      </div>
    </div>
  )
}

export default Login
